import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';

/*
various functions and utils for creating complex form elements
 */
export const makeInput = ({label, fieldname, required, pattern, validationMessage, as = 'input', type = 'string',
							  extract = d => d[fieldname], defaultValue = '', options, id = ''},
						  data, onChange) => {
	return (
		<InputGroup
			hasValidation
			key = {fieldname}>
			<InputGroup.Text>
				{label}
			</InputGroup.Text>
			<Form.Control
				id = {id}
				required = {required}
				pattern = {pattern}
				name = {fieldname}
				onChange = {onChange}
				value = {extract(data) || defaultValue}
				type = {type}
				as = {as}>
			{options}
			</Form.Control>
			<Form.Control.Feedback type = {'invalid'}>
				{validationMessage}
			</Form.Control.Feedback>
		</InputGroup>
	);
}

export const makeCountrySelection = allowEmpty => {
	const options = [
		<option key = {'DE'} value = {'Deutschland'}>{'Deutschland'}</option>,
		<option key = {'AUT'} value = {'Österreich'}>{'Österreich'}</option>,
		<option key = {'CH'} value = {'Schweiz'}>{'Schweiz'}</option>
	];

	if (allowEmpty)
		options.unshift(<option key = {'NoCountry'} value = {''}>{''}</option>);

	return {
		label: 'Land',
		fieldname: 'country',
		as: 'select',
		options: options,
	};
}

export const genders = {
	MALE: {
		short: ['M'],
		label: 'Männlich',
	},
	FEMALE: {
		short: ['W', 'F'],
		label: 'Weiblich',
	},
	DIVERSE: {
		short: ['D'],
		label: 'Divers',
	},
};

export const lookupGenderKeyFromShort = g => Object.entries(genders).find(([k, v]) => v.short.includes(g.toUpperCase()))[0];

export const makeGenderSelection = extract => ({
	label: 'Geschlecht',
	fieldname: 'gender',
	as: 'select',
	options: options,
	extract: extract,
})

const options = Object.entries(genders).map(([id, g]) => (
	<option
		key = {g.short[0]}
		value = {id}>
		{g.label}
	</option>
));


// validation

// German characters, potentially followed by any number of groups of hyphen or space and characters
// ie. foo, foo-bar, foo bar; but not -foo, not foo-
export const name = {
	pattern: '[a-zA-ZßäöüÄÖÜ]{1,}(?:[- ][a-zA-ZßäöüÄÖÜ]{1,})*',
	message: 'Bitte einen gültigen Namen eingeben',
};

export const surname = {
	pattern: name.pattern,
	message: 'Bitte einen gültigen Nachnamen eingeben',
};

export const street = {
	pattern: name.pattern,
	message: 'Bitte eine gültige Straße eingeben',
};

export const city = {
	pattern: name.pattern,
	message: 'Bitte eine gültige Stadt eingeben',
};

/* accepts 1//2 and 1/ which it shouldn't */
export const houseNumber = {
	pattern: '[1-9][0-9]*[/]?[0-9]*[a-z]*',
	message: 'Bitte eine gültige Hausnummer eingeben',
};

export const zipCode = {
	pattern: '[0-9]{1,5}',
	message: 'Bitte eine gültige Postleitzahl eingeben',
};

// digits, - or /, digits
export const phoneNumber = {
	pattern: '^[0-9]*([-/ ]{1}[0-9]{1,})*$',
	message: 'Bitte eine gültige Telefon-Nummer eingeben',
};

// taken from https://www.regular-expressions.info/index.html
export const emailAddress = {
	pattern: '\\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\\b',
	message: 'Bitte eine gültige E-Mail-Adresse eingeben',
};

export const number = {
	pattern: '0|([1-9][0-9]*)',
	message: 'Bitte eine Zahl eingeben',
};
